var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 22,
    viewBox: "0 0 27 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3471 10.9953C26.3382 10.0305 25.9495 9.10813 25.2652 8.42797L17.3981 0.54254C17.0545 0.200989 16.5897 0.00927734 16.1052 0.00927734C15.6207 0.00927734 15.1559 0.200989 14.8124 0.54254C14.6405 0.713017 14.5041 0.915839 14.411 1.13931C14.3179 1.36278 14.2699 1.60247 14.2699 1.84455C14.2699 2.08664 14.3179 2.32633 14.411 2.5498C14.5041 2.77326 14.6405 2.97609 14.8124 3.14656L20.8456 9.1615H2.50741C2.02105 9.1615 1.55461 9.3547 1.2107 9.69861C0.86679 10.0425 0.673584 10.509 0.673584 10.9953C0.673584 11.4817 0.86679 11.9481 1.2107 12.292C1.55461 12.6359 2.02105 12.8291 2.50741 12.8291H20.8456L14.8124 18.8624C14.467 19.2053 14.2721 19.6713 14.2704 20.1579C14.2686 20.6446 14.4603 21.112 14.8032 21.4573C15.1461 21.8026 15.6121 21.9975 16.0987 21.9993C16.5854 22.001 17.0527 21.8093 17.3981 21.4664L25.2652 13.581C25.9539 12.8963 26.343 11.9665 26.3471 10.9953Z",
    fill: "#074269"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrowRight.5cc0e721f76598167a81652625000489.svg";
export { ForwardRef as ReactComponent };